import React from 'react'

class Form extends React.Component {

  startEditing = () => {
    this.setState({
      editing: true,
      data: this.props.data
    });
  }

  cancelEditing = () => {
    this.setState({
      editing: false,
      data: this.props.data,
      errors: {}
    });
  }

  startAdding = () => {
    this.setState({adding: true});
  }

  cancelAdding = () => {
    this.setState({
      adding: false,
      data: this.newItem
    });
  }

  updateInput = e => {
    this.setState({
      data:{
        ...this.state.data,
        [e.target.name]: e.target.value
      }
    });
  }

  updateSelect = (e,field) => {
    this.setState({
      data:{
        ...this.state.data,
        [field]:e.value
      }
    });
  }

  updateDate = (e, field) => {
    this.setState({
      data:{
        ...this.state.data,
        [field]: e.format('Y-MM-DD')
      }
    });
  }

  handleChBox = e => {
    const val = e.target.checked ? 1 : 0;
    this.setState({
      data:{
        ...this.state.data,
        [e.target.name]: val
      }
    });
  }

  toggleDelConf = e => {
    if (e.preventDefault) e.preventDefault();
    if (e.stopPropagation) e.stopPropagation();
    const delConf = !this.state.delConf;
    this.setState({delConf:delConf});
  }

  changeSort(asc){
    return (asc === 0) ? 1 : 0;
  }

}

export default Form;



// WEBPACK FOOTER //
// ./src/components/ui/Form.jsx